<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <product-form :create="true" @saved="editProduct"></product-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            editProduct(product) {
                this.$router.push({name: 'product', params: {id: product.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ProductCreate.vue?ee76aec4